import _get from "lodash/get";
import _keyBy from "lodash/keyBy";
import { denormalize } from "normalizr";
import * as qs from "query-string";
import React from "react";
import ReactHighcharts from "react-highcharts";
import { connect } from "react-redux";
import { statusPalette } from "../../helpers/constants/colorPalettes";
import { pageResultsSchema } from "../../schemas/index";
import { history } from "../../store";
import * as styles from "../../styles/components/PageDriversGraph.css";
import { DRIVER_ORDER } from "./Drivers/info";
import { BENCHMARK_POINTS } from "./Drivers/info";

class PageDriversGraph extends React.Component {
    makeScorePointForDriver = ({ label, benchmark, score }) => {
        let color;
        if (Math.round(score) >= Math.round(benchmark) + BENCHMARK_POINTS) {
            color = statusPalette.good;
        } else if (
            Math.round(score) <=
            Math.round(benchmark) - BENCHMARK_POINTS
        ) {
            color = statusPalette.bad;
        } else {
            color = statusPalette.okGray;
        }

        return { color, y: score, driver: label };
    };

    makeBenchmarkSeriesForDriver = ({ label, benchmark }, index) => {
        return {
            type: "line",
            name: label,
            // Each "category" on the x-axis starts at x = index and has width = 1. All of the columns fit in that
            // interval. If we plot a point at x = index, it will be centered on the columns. This plots each
            // benchmark as a series of 2 points spanning 70% of the category.
            data: [[index - 0.35, benchmark], [index + 0.35, benchmark]],
            color: "black",
            enableMouseTracking: false,
            // Disable the marker to hide the points. The line connecting them will still appear.
            marker: { enabled: false }
        };
    };

    makeGraphConfig = drivers => {
        const { queryString: currentQueryString } = this.props;

        return {
            chart: {
                type: "column",
                height: 350
            },
            credits: { enabled: false },
            legend: { enabled: false },
            title: { text: "" },
            series: [
                {
                    cursor: "pointer",
                    data: drivers.map(this.makeScorePointForDriver),
                    events: {
                        click: function(event) {
                            const driver = event.point.category;
                            const newQueryString = qs.stringify({
                                ...currentQueryString,
                                driver
                            });
                            return history.push({
                                search: `?${newQueryString}`
                            });
                        }
                    },
                    groupPadding: 0.2
                },
                ...drivers.map(this.makeBenchmarkSeriesForDriver)
            ],
            xAxis: {
                categories: drivers.map(({ label }) => label),
                min: 0,
                max: drivers.length - 1,
                tickWidth: 0,
                labels: {
                    style: {
                        fontFamily: "proxima-nova, sans-serif",
                        fontSize: "14px"
                    }
                }
            },
            yAxis: {
                title: { text: "" }
            },
            tooltip: {
                useHTML: true,
                outside: true,
                formatter: function() {
                    return `
                    <b>${this.point.driver}</b>
                    <br/>
                    Score: ${this.y}
                `;
                }
            },
            plotOptions: {
                series: {
                    animation: false
                }
            }
        };
    };

    render = () => {
        const { drivers } = this.props;
        const config = this.makeGraphConfig(drivers);
        return (
            <div className={styles.pageDriversGraph}>
                <div className={styles.legend}>
                    <div className={styles.benchmarkLine} />
                    <p className={styles.benchmarkLabel}>Industry benchmark</p>
                </div>
                <div className={styles.graph}>
                    <ReactHighcharts config={config} />
                </div>
            </div>
        );
    };
}

function mapStateToProps(state, props) {
    const { pageId } = props;

    const pageResults =
        denormalize(pageId, pageResultsSchema, state.api) || null;

    const indexedDrivers = _keyBy(pageResults.drivers, "driver");

    const drivers = DRIVER_ORDER.map(driver => indexedDrivers[driver])
        .filter(driver => !!driver)
        .map(driver => ({
            label: _get(driver, "driver"),
            score: Math.round(driver.driverScore),
            benchmark: _get(driver, ["benchmarks", "avg"], null)
        }));

    const queryString = state.queryString;

    return {
        drivers,
        queryString
    };
}

export default connect(
    mapStateToProps,
    null
)(PageDriversGraph);



// WEBPACK FOOTER //
// ./src/components/Results/PageDriversGraph.js